import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Row } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Page from "src/components/Page";
import OurStory from "src/content/OurStory";
import getDefaultOg from "src/functions/getDefaultOg";
import { sStory } from "src/styles/sStory.module.scss";

export default function Story() {
  const { locale: lang } = useRouter();
  return (
    <>
      <Headers data={getDefaultOg(lang)} />
      <Page className={composeClassNames([sStory, "page-story"])}>
        <Header />
        <Content fluid={`lg`}>
          <Row>
            <OurStory />
          </Row>
          <br />
          <br />
          <br />
          <br />
        </Content>
        <Footer />
      </Page>
      <Footers />
    </>
  );
}
